<!-- Root router-outlet -->
<router-outlet id="app-outlet"></router-outlet>
